import { Permission } from '@/shared/modules/permissions';
import {
  type RoleAdminAccess,
  useRoleAdminAccess as useSharedRoleAdminAccess,
} from '@/shared/modules/role-board/use-role-admin-access';

export type { RoleAdminAccess };

/**
 * What the current caller may do on the entity roles board — a thin wrapper
 * over the shared factory (`@/shared/modules/role-board/use-role-admin-access`,
 * GP-3853 Task 11 fix round 1) fixing `manage`/`assign` to
 * `EntityManageRoles`/`EntityAssignRoles`. Kept as its own named export (not
 * inlined at call sites) so this module's existing consumers and tests don't
 * need to change.
 */
export const useRoleAdminAccess = (): RoleAdminAccess =>
  useSharedRoleAdminAccess({
    manage: Permission.EntityManageRoles,
    assign: Permission.EntityAssignRoles,
  });
